import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

// --- AUTHENTICATION PAGES ---
/**
 * Authentication related pages
 */
const Login = lazy(() => import("pages/Authentication/LoginPages/Login"));
const Logout = lazy(() => import("pages/Authentication/Logout"));
const Verification = lazy(() => import("pages/Authentication/LoginPages/Verification"));
const ForgetPwd = lazy(() => import("pages/Authentication/ForgetPasswordPages/ForgetPassword"));
const ForgetPwdOtp = lazy(() => import("pages/Authentication/ForgetPasswordPages/ForgetPasswordOtp"));
const ForgetPasswordStaff = lazy(() => import("pages/Authentication/ForgetPasswordPages/ForgetPasswordStaff"));
const StaffForgetPwdOtp = lazy(() => import("pages/Authentication/ForgetPasswordPages/StaffForgetPasswordOtp"));
const ParticipantLogin = lazy(() => import("pages/Authentication/LoginPages/ParticipantLogin"));
const SuperAdminLogin = lazy(() => import("pages/Authentication/LoginPages/SuperAdmin"));
const AdminLogin = lazy(() => import("pages/Authentication/LoginPages/LoginAdmin"));
// const StaffLogin = lazy(() => import('pages/Authentication/LoginPages/LoginStaff'));

// --- PROFILE PAGES ---
/**
 * Profile related pages
 */
const UserProfile = lazy(() => import("pages/Authentication/ProfilePages/user-profile"));
const CompanyProfile = lazy(() => import("pages/Authentication/ProfilePages/company-profile"));
const EmployeeProfile = lazy(() => import("pages/Authentication/ProfilePages/employee-profile"));

// --- SUPPORT WORKER PORTAL PAGES ---
/**
 * Support worker related pages
 */
const SupportWorker = lazy(() => import("pages/EmployeePortal/Dashboard"));
const SupportWorkerTask = lazy(() => import("pages/EmployeePortal/Task"));
const SupportWorkerParticipantView = lazy(() => import("pages/EmployeePortal/ParticipantView/ProjectOverview/projects-overview"));
const EmployeeDocumentsList = lazy(() => import("pages/EmployeePortal/EmployeeDocumentsList"));
const EmpPrivacyPolicy = lazy(() => import("pages/EmployeePortal/PravicyPolicy"));
const EmpFileManager = lazy(() => import("pages/EmployeePortal/FileManager/View"));
const ProgressNotesView = lazy(() => import("pages/EmployeePortal/ProjectOverview/utils/ProgressNotesView"));
const EmpAvailability = lazy(() => import("pages/EmployeePortal/Availability/View"));
const EmpOpenShift = lazy(() => import("pages/EmployeePortal/OpenShift/index"));
const RequestedOpenShifts = lazy(() => import("pages/EmployeePortal/OpenShift/RequestedShifts"));
const EmpMedication = lazy(() => import("pages/EmployeePortal/Medication"));
const Links = lazy(() => import("pages/EmployeePortal/Links"));
const Visitors = lazy(() => import("pages/EmployeePortal/VisitorRegister"));
const SupportWorkerTimeSheet = lazy(() => import("pages/EmployeePortal/TimeSheet"));
const Complaint = lazy(() => import("pages/EmployeePortal/Complaint"));

// --- DASHBOARD ---
/**
 * Dashboard related pages
 */
const Dashboard = lazy(() => import("pages/Dashboard"));

// --- CALENDAR ---
/**
 * Calendar related pages
 */
const Calender = lazy(() => import("pages/Calender"));

// --- EMAIL ---
/**
 * Email related pages
 */
const Email = lazy(() => import("pages/Email"));

// --- ERROR PAGES ---
/**
 * Error related pages
 */
const Pages404 = lazy(() => import("pages/pages-404"));
const Pages500 = lazy(() => import("pages/pages-500"));
const PageNoAccess = lazy(() => import("pages/page-no-access"));

// --- ADMIN PAGES ---
/**
 * Admin related pages
 */
const Admins = lazy(() => import("pages/Admin"));

// --- PARTICIPANT PAGES ---
/**
 * Participant related pages
 */
const Participants = lazy(() => import("pages/Participants"));
const ParticipantCalender = lazy(() => import("pages/Participants/Calender/index"));
const ParticipantMedical = lazy(() => import("pages/Participants/Components/Medication"));
const ParticipantView = lazy(() => import("pages/Participants/Overview"));

// --- SERVICE PAGES ---
/**
 * Service related pages
 */
const Services = lazy(() => import("pages/Service"));
const ServiceOverview = lazy(() => import("pages/Service/Components/View"));

// --- EMPLOYEE PAGES ---
/**
 * Employee related pages
 */
const Employee = lazy(() => import("pages/Employee"));
const EmployeeView = lazy(() => import("pages/Employee/Overview"));
const EmployeeCalender = lazy(() => import("pages/Employee/Calender/index"));
const EmployeePendingDocs = lazy(() => import("pages/Employee/Components/PendingDocs"));
const Availability = lazy(() => import("pages/Employee/Components/Availability"));
const EmployeeTimeSheet = lazy(() => import("pages/Employee/Components/TimeSheet"));
const TimeSheetPreview = lazy(() => import("pages/Employee/Components/TimeSheetPreview"));

// --- MANAGER PAGES ---
/**
 * Manager related pages
 */
const Manager = lazy(() => import("pages/Manager"));
const ManagerView = lazy(() => import("pages/Manager/Overview/index"));

// --- SHIFT ROSTER PAGES ---
/**
 * Shift Roster related pages
 */
const ShiftRoaster = lazy(() => import("pages/ShiftRoster"));
const ShiftRecord = lazy(() => import("pages/ShiftRoster/Components/LogPreview"));
const OpenShift = lazy(() => import("pages/OpenShift/index"));

// --- TASK PAGES ---
/**
 * Task related pages
 */
const Tasks = lazy(() => import("pages/Task"));
const TaskRecord = lazy(() => import("pages/Task/Logs/LogPreview"));
const TaskOverview = lazy(() => import("pages/TeamTask/Components/View_"));
const TeamTask = lazy(() => import("pages/TeamTask"));
const TeamProgressNote = lazy(() => import("pages/TeamTask/Components/ProgressNotes"));
const MyShifts = lazy(() => import("pages/TeamTask/Components/MyShifts"));
const MyTaskView = lazy(() => import("pages/TeamTask/Components/View_"));

// --- SUPER ADMIN PAGES ---
/**
 * Super Admin related pages
 */
const SuperAdmin = lazy(() => import("pages/SuperAdmin"));
const AdminOverview = lazy(() => import("pages/SuperAdmin/Components/View"));

// --- VEHICLE PAGES ---
/**
 * Vehicle related pages
 */
const Vehicles = lazy(() => import("pages/Vehicles"));
const VehiclesOverview = lazy(() => import("pages/Vehicles/Components/View"));
const VehicleRecord = lazy(() => import("pages/Vehicles/Components/LogPreview"));

// --- FILE MANAGER PAGES ---
/**
 * File Manager related pages
 */
const FileManager = lazy(() => import("pages/FileManager"));
const Files = lazy(() => import("pages/FileManager/FolderRoutes/Files"));
const AssignedUsers = lazy(() => import("pages/FileManager/Components/AssignedUserList"));

// --- INCIDENT REPORT PAGES ---
/**
 * Incident Report related pages
 */
const Registers = lazy(() => import("pages/IncidentReport"));
const ViewReport = lazy(() => import("pages/IncidentReport/Components/ViewReport"));
const IncidentRecord = lazy(() => import("pages/IncidentReport/Logs/LogPreview"));

// --- RISK ASSESSMENT PAGES ---
/**
 * Risk Assessment related pages
 */
const RiskAssesment = lazy(() => import("pages/RiskAssessment"));

// --- INVOICE PAGES ---
/**
 * Invoice related pages
 */
const Invoice = lazy(() => import("pages/Invoice"));
const InvoiceView = lazy(() => import("pages/Invoice/Components/View"));
const InvoicePreview = lazy(() => import("pages/Invoice/Components/InvoicePreview"));
const BulkBillPreview = lazy(() => import("pages/Invoice/Components/BulkBillPreview"));

// --- NOTICE BOARD PAGES ---
/**
 * Notice Board related pages
 */
const NoticeBoard = lazy(() => import("pages/NoticeBoard/index"));
const SlidesView = lazy(() => import("pages/NoticeBoard/Components/View"));
const NotcieBoardLogin = lazy(() => import("pages/Authentication/LoginPages/LoginNotceBoard"));
const NoticeBoardSlidesLogin = lazy(() => import("pages/NoticeBoard/Components/NoticeSlides"));

// --- TRAINING & POLICY PAGES ---
/**
 * Training & Policy related pages
 */
const Training = lazy(() => import("pages/Training"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));

// --- MEDICATION PAGES ---
/**
 * Medication related pages
 */
const Medication = lazy(() => import("pages/Medication"));
const MedicineView = lazy(() => import("pages/Medication/Components/View"));
const MedicineRecord = lazy(() => import("pages/Participants/Logs/LogPreview"));

// --- ROLE ACCESS PAGES ---
/**
 * Role Access related pages
 */
const RoleAccess = lazy(() => import("pages/RoleAccess"));
const CreateRole = lazy(() => import("pages/RoleAccess/Form/RoleForm"));

// --- SERVICES PAGES ---
/**
 * Services related pages
 */
const ServiceRecord = lazy(() => import("pages/ServiceRecord"));
const ServiceRecordView = lazy(() => import("pages/ServiceRecord/Components/View"));
const ServiceLogs = lazy(() => import("pages/ServiceRecord/Components/LogPreview"));

// --- PRESCRIBERS PAGES ---
/**
 * Prescriber related pages
 */
const Prescriber = lazy(() => import("pages/Prescriber"));

// --- LOCATION PAGES ---
/**
 * Location related pages
 */
const Location = lazy(() => import("pages/Location"));
const LocationView = lazy(() => import("pages/Location/View"));

// --- TEMPLATE PAGES ---
/**
 * Template related pages
 */
const Template = lazy(() => import("pages/Template"));

// --- HAZARD REPORT PAGES ---
/**
 * Hazard Report related pages
 */
const HazardReport = lazy(() => import("pages/HazardReport"));
const ViewHazardReport = lazy(() => import("pages/HazardReport/Components/View"));

// --- CHATGPT PAGES ---
/**
 * ChatGPT related pages
 */
const ChatGPT = lazy(() => import("pages/ChatGPT"));
const ReportRecord = lazy(() => import("pages/ChatGPT/Logs/LogPreview"));
const ChatGPTReport = lazy(() => import("pages/ChatGPT/Components/ReportPdf"));

// --- PROGRESS NOTE PAGES ---
/**
 * Progress Note related pages
 */
const ProgressNoteTemplate = lazy(() => import("pages/ProgressNoteTemplate"));

// --- INTEGRATION PAGES ---
/**
 * Integration related pages
 */
const IntegrationCallBack = lazy(() => import("pages/Integration"));

// --- COMPLAINTS PAGES ---
/**
 * Complaints related pages
 */
const Complaints = lazy(() => import("pages/Complaints"));
const ComplaintPreview = lazy(() => import("pages/Complaints/Components/ComplaintPreview"));

// --- FUNDING PAGES ---
/**
 * Funding related pages
 */
const Funding = lazy(() => import("pages/Funding/index"));

import { me } from "constants/Client";

// For redirecting to initial pages
const check = user => {
  if (user.role == "super admin") return <Redirect to='/superadmin' />;
  if (user.role == "admin" || user.role == "manager" || user.role == "accountant") return <Redirect to='/dashboard' />;
  if (user.role == "staff") return <Redirect to='/staff-view' />;
  if (user.role == "participant") return <Redirect to='/participant-task-report' />;
};

const authProtectedRoutes = [
  //URL for staff role
  { path: "/trainings", component: () => <Links /> },
  { path: "/staff-view", component: () => <SupportWorker /> },
  { path: "/employee-open-shift", component: () => <EmpOpenShift /> },
  { path: "/task-medication/:id/:taskId", component: () => <EmpMedication /> },
  { path: "/privacy-policies", component: () => <EmpPrivacyPolicy /> },
  { path: "/employee-file-manager", component: () => <EmpFileManager /> },
  { path: "/employee-availability", component: () => <EmpAvailability /> },
  { path: "/requested-open-shift", component: () => <RequestedOpenShifts /> },
  { path: "/employee-documents-list", component: () => <EmployeeDocumentsList /> },
  { path: "/details/:id", component: () => <SupportWorkerTask /> },
  { path: "/progress-notes/:id", component: () => <ProgressNotesView /> },
  { path: "/details/participant/:id", component: () => <SupportWorkerParticipantView /> },
  { path: "/visitor-register", component: () => <Visitors /> },
  { path: "/support-worker-time-sheet", component: () => <SupportWorkerTimeSheet /> },
  { path: "/support-worker-complaint", component: () => <Complaint /> },

  // superadmin
  { path: "/superadmin", component: () => <SuperAdmin /> },
  { path: "/superadmin/admin-overview/:id/:name", component: () => <AdminOverview /> },

  //URL for admin & manager & accountant role
  //dashborad's pages
  { path: "/dashboard", component: () => <Dashboard /> },

  // ROLE ACCESS
  { path: "/role-access", component: () => <RoleAccess /> },
  { path: "/role-access/create", component: () => <CreateRole /> },
  { path: "/role-access/create/:id", component: () => <CreateRole /> },

  // manager's pages
  { path: "/managers-list", component: () => <Manager /> },
  { path: "/managers-list/manager-overview/:id", component: () => <ManagerView /> },

  // participant's pages
  { path: "/client-list", component: () => <Participants /> },
  { path: "/client-list/medication/:id", component: () => <ParticipantMedical /> },
  { path: "/client-list/client-overview/:id", component: () => <ParticipantView /> },
  { path: "/client-list/participant-calender/:id", component: () => <ParticipantCalender /> },

  // service's pages
  { path: "/service-list", component: () => <Services /> },
  { path: "/service-list/service-overview/:id", component: () => <ServiceOverview /> },

  //staff's pages
  { path: "/staff-list", component: () => <Employee /> },
  { path: "/staff-list/staff-overview/:id", component: () => <EmployeeView /> },
  { path: "/staff-list/staff-calender/:id", component: () => <EmployeeCalender /> },
  { path: "/staff-list/time-sheet/:id", component: () => <EmployeeTimeSheet /> },
  { path: "/pending-docs", component: () => <EmployeePendingDocs /> },

  //calender's pages
  { path: "/calender", component: () => <Calender /> },
  { path: "/availability/:id", component: () => <Availability /> },

  //task's pages
  { path: "/task-list", component: () => <Tasks /> },
  { path: "/task-list/task-overview/:id", component: () => <TaskOverview /> },
  { path: "/task-record/:id", component: () => <TaskRecord /> },

  //team task
  { path: "/my-task", component: () => <TeamTask /> },
  { path: "/my-shift", component: () => <MyShifts /> },
  { path: "/task-list/:id", component: () => <TeamProgressNote /> },
  // { path: '/my-task/overview/:id', component: () => <TaskOverview isTeamTask={true} /> },
  { path: "/my-task/overview/:id", component: () => <MyTaskView hideControls /> },

  //vehicle's pages
  { path: "/vehicle-list", component: () => <Vehicles /> },
  { path: "/vehicle-list/vehicle-overview/:id", component: () => <VehiclesOverview /> },
  { path: "/vehicle-record/:id", component: () => <VehicleRecord /> },

  //incident page
  { path: "/registers", component: () => <Registers /> },
  { path: "/preview-incident-form/:id/:company_unique_no", component: () => <ViewReport /> },
  { path: "/incident-record/:id", component: () => <IncidentRecord /> },

  //risk assesment page
  { path: "/risk-assesement", component: () => <RiskAssesment /> },

  //invoice pages
  { path: "/invoice", component: () => <Invoice /> },
  { path: "/invoice/invoice-overview/:id", component: () => <InvoiceView /> },

  // training pages
  { path: "/training-links", component: () => <Training /> },

  // privacy policy pages
  { path: "/privacy-policy", component: () => <PrivacyPolicy /> },

  // vehicle & service record pages
  { path: "/service-record/:id", component: () => <ServiceRecord /> },
  { path: "/service-record/overview/:id", component: () => <ServiceRecordView /> },
  { path: "/service-record-log/:id", component: () => <ServiceLogs /> },

  //file manager
  { path: "/client-list/file-manager/:id", component: () => <FileManager /> },
  { path: "/client-list/file-manager/:name/:id", component: () => <Files /> },
  { path: "/client-list/assigned-members/:id", component: () => <AssignedUsers /> },

  // chatgpt
  { path: "/participant-task-report", component: () => <ChatGPT /> },
  { path: "/participant-task-report-view/:id", component: () => <ChatGPTReport /> },
  { path: "/report-record/:id", component: () => <ReportRecord /> },

  //company profile
  { path: "/company-profile", component: () => <CompanyProfile /> },

  //employee profile
  { path: "/employee-profile", component: () => <EmployeeProfile /> },

  // location
  { path: "/location", component: () => <Location /> },
  { path: "/location/:id", component: () => <LocationView /> },

  // shift roaster
  { path: "/shift", component: () => <ShiftRoaster /> },
  { path: "/shift-record/:id", component: () => <ShiftRecord /> },

  // open shifts
  { path: "/open-shift", component: () => <OpenShift /> },

  // notice board
  { path: "/notice-board", component: () => <NoticeBoard /> },
  { path: "/notice-board/:id", component: () => <SlidesView /> },

  //Email
  { path: "/email-inbox", component: () => <Email /> },

  //Admin
  { path: "/admins", component: () => <Admins /> },

  // chatgpt
  { path: "/participant-task-report", component: () => <ChatGPT /> },
  { path: "/report-record/:id", component: () => <ReportRecord /> },

  // template
  { path: "/template", component: () => <Template /> },

  // prescribers
  { path: "/medication/prescribers", component: () => <Prescriber /> },

  // Medication
  { path: "/medication", component: () => <Medication /> },
  { path: "/medication/:id", component: () => <MedicineView /> },
  { path: "/participant-medication-record/:id", component: () => <MedicineRecord /> },

  // Hazard report
  { path: "/hazard-report", component: () => <HazardReport /> },
  { path: "/hazard-report/:id", component: () => <ViewHazardReport /> },

  // ProgressNote template
  { path: "/pn-template", component: () => <ProgressNoteTemplate /> },

  // Complaints
  { path: "/complaints", component: () => <Complaints /> },
  { path: "/complaint/:id", component: () => <ComplaintPreview /> },
  { path: "/my-complaint", component: () => <Complaint /> },

  // Funding Dashboard
  { path: "/funding/:id", component: () => <Funding /> },

  //user profile
  { path: "/profile", component: UserProfile },

  { path: "/logout", component: Logout },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => check(me()) },
  { path: "/no-access", component: PageNoAccess },
  { path: "/*", component: Pages404 },
];

const openRoutes = [
  { path: "/staff-list/time-sheet/:id/:from/:to", component: TimeSheetPreview },
  { path: "/view-invoice/:from/:to/:part_id", component: InvoicePreview },
  { path: "/notice-board-view/:id", component: NoticeBoardSlidesLogin },
  { path: "/view-bulk-bill", component: BulkBillPreview },
  { path: "/nb/:id", component: NotcieBoardLogin },
  { path: "/auth/connect", component: IntegrationCallBack },
];

const publicRoutes = [
  { path: "/report-login/:name", component: ParticipantLogin },
  { path: "/admin-login", component: AdminLogin },
  { path: "/s", component: SuperAdminLogin },
  { path: "/staff-login", component: AdminLogin },
  { path: "/login", component: AdminLogin },
  { path: "/verification", component: Verification },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/forgot-password-staff", component: ForgetPasswordStaff },
  { path: "/forgot-password-reset", component: ForgetPwdOtp },
  { path: "/forgot-password-reset-staff", component: StaffForgetPwdOtp },
  { path: "/register", component: Login },
  { path: "/page500", component: Pages500 },
  { path: "/404", component: Pages404 },
];

export { publicRoutes, authProtectedRoutes, openRoutes };
